import IncidentReport from "../../components/IncidentReport/index";

const IncidentReportPage = () => {
  return (
    <>
      <IncidentReport />
    </>
  );
};

export default IncidentReportPage; 